/**
 * @generated SignedSource<<39193b28e56af9fe5faf07cbd4fa14e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveLinkedEventInput = {
  clientMutationId?: string | null;
  streamId: string;
};
export type LinkEventModalRemoveEventMutation$variables = {
  input: RemoveLinkedEventInput;
};
export type LinkEventModalRemoveEventMutation$data = {
  readonly removeLinkedEvent: {
    readonly stream: {
      readonly id: string;
      readonly linkedEvent: {
        readonly finalOccurrence: string | null;
        readonly guid: string;
        readonly id: string;
        readonly nextOccurrence: {
          readonly end: string | null;
          readonly start: string | null;
        } | null;
        readonly recurrenceRule: ReadonlyArray<string | null> | null;
        readonly title: string;
      } | null;
      readonly linkedEventGuid: string | null;
    };
  } | null;
};
export type LinkEventModalRemoveEventMutation = {
  response: LinkEventModalRemoveEventMutation$data;
  variables: LinkEventModalRemoveEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedEventGuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalOccurrence",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkEventModalRemoveEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveLinkedEventPayload",
        "kind": "LinkedField",
        "name": "removeLinkedEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "linkedEvent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "nextOccurrence",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkEventModalRemoveEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveLinkedEventPayload",
        "kind": "LinkedField",
        "name": "removeLinkedEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "linkedEvent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "nextOccurrence",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "04686375b152744d1aa7a95727053904",
    "id": null,
    "metadata": {},
    "name": "LinkEventModalRemoveEventMutation",
    "operationKind": "mutation",
    "text": "mutation LinkEventModalRemoveEventMutation(\n  $input: RemoveLinkedEventInput!\n) {\n  removeLinkedEvent(input: $input) {\n    stream {\n      id\n      linkedEventGuid\n      linkedEvent {\n        id\n        guid\n        title\n        recurrenceRule\n        nextOccurrence {\n          start\n          end\n          id\n        }\n        finalOccurrence\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7261ee6f611ec154170ca1fba4200e1";

export default node;
